import { render, staticRenderFns } from "./DataviewNew.vue?vue&type=template&id=15a9014e"
import script from "./DataviewNew.vue?vue&type=script&lang=js"
export * from "./DataviewNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports